import CarLeftListContainer from "../../../components/car/listing/CarLeftList";

const CarLeftList = () => {
  return <CarLeftListContainer />;
};

export default CarLeftList;
